const FECHA_ACTUAL = (state, fecha_actual) => {
    state.fecha_actual = fecha_actual;
};

export default {
    FECHA_ACTUAL,
};